/**
 * Format a Date as YYYY-MM-DD using LOCAL timezone, not UTC.
 *
 * Using `.toISOString().split('T')[0]` for user-facing dates causes an
 * off-by-one bug for users east of UTC (CET, EET, Asia, Australia, etc.):
 * local midnight is still the previous day in UTC. This helper preserves the
 * date the user actually sees on their clock.
 */
export function formatLocalDate(d) {
  const dt = d instanceof Date ? d : new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Today as YYYY-MM-DD in the user's local timezone. */
export function todayLocal() {
  return formatLocalDate(new Date());
}

/** N days ago as YYYY-MM-DD in the user's local timezone. */
export function daysAgoLocal(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return formatLocalDate(d);
}
